export default "__VITE_ASSET__PJYTnvUa__"